const factorySchedule = {
  FACTORYSCHEDULE: 'FACTORYSCHEDULE',
  FACTORYSCHEDULES: 'FACTORYSCHEDULES',
};

export { factorySchedule };
